import { render, staticRenderFns } from "./PaymentOptionComponent.vue?vue&type=template&id=a853ded2&"
import script from "./PaymentOptionComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentOptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports